const React = require('react');
const Node = require('./Node');

class ListMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected:
  this.props.deviceType === 'desktop'
    ? this.props?.category?.selected
    : false,
    };
    this.handleCheck = this.handleCheck.bind(this);
  }

  handleCheck() {
    this.setState((oldState) => ({ selected: !oldState.selected }));
  }

  render() {
    const { page: currentPage } = this.props;
    const node = {};
    const { buParam, quantityOfTrue, location } = this.props;
    const isMShops = buParam && buParam.mshops && +quantityOfTrue === 1;

    node.id = this.props.category.id;
    node.name = this.props.category.name;
    node.class_name = this.props.class_name;
    node.id_name = this.props.id_name;
    node.level = this.props.level;

    let mshopsCategoryId = '';
    let applicationManagementCategoryId = '';
    let securityCategoryId = '';

    if (location === 'pt_br') {
      mshopsCategoryId = 215;
      applicationManagementCategoryId = 29;
      securityCategoryId = 495;
    } else if (location === 'es_ar') {
      mshopsCategoryId = 214;
      applicationManagementCategoryId = 59;
      securityCategoryId = 492;
    } else {
      mshopsCategoryId = 219;
      applicationManagementCategoryId = 19;
      securityCategoryId = 496;
    }

    const isApplicationManagement = currentPage && applicationManagementCategoryId === currentPage.category_id;
    const isSecurity = currentPage && securityCategoryId === currentPage.category_id;

    const categoryData = this.props.category;

    const mshopsData = categoryData.children_categories.filter(
      (mshops) => mshops.id === mshopsCategoryId,
    );

    const applicationManagementData = categoryData.children_categories.filter(
      (application) => application.id === applicationManagementCategoryId,
    );

    const mshopsCategory = mshopsData[0];
    const applicationManagementCategoryData = applicationManagementData[0];

    const securityData = isSecurity
      ? categoryData.children_categories.filter(
        (security) => security.id === applicationManagementCategoryId,
      )
      : '';
    const securityCategoryData = securityData[0];


    const defaultFilterCondition = this.props.category.children_categories;
    const mshopsFilterCondition = isMShops && mshopsCategory?.visible && mshopsCategory.pages.length >= 1;
    const applicationManagementFilterCondition = isApplicationManagement && applicationManagementCategoryData?.visible && applicationManagementCategoryData.pages.length >= 1;
    const securityFilterCondition = isSecurity && securityCategoryData?.visible && securityCategoryData.pages.length >= 1;
    let subList = null;

    // management of applications and mshops - filter by tabs
    const listMenuProps = {
      deviceType: this.props.deviceType,
      class_name: `sub-${node.class_name}`,
      id_name: `sub-${node.id_name}`,
      level: node.level,
    };

    if (mshopsFilterCondition) {
      subList = <ListMenu key={mshopsCategory.id} category={mshopsCategory} menuOrder={mshopsCategory.menu_order} {...listMenuProps} />;
    } else if (applicationManagementFilterCondition) {
      subList = <ListMenu key={applicationManagementCategoryData.id} category={applicationManagementCategoryData} menuOrder={applicationManagementCategoryData.menu_order} {...listMenuProps} />;
    } else if (securityFilterCondition) {
      subList = <ListMenu key={securityCategoryData.id} category={securityCategoryData} menuOrder={securityCategoryData.menu_order} {...listMenuProps} />;
    } else if (defaultFilterCondition) {
      const filteredCategories = defaultFilterCondition.filter(
        (category) => category.visible && category.pages.length >= 1,
      );
      subList = filteredCategories.map((category, index) => (
        <ListMenu key={category.id} category={category} menuOrder={category.menu_order} id_name={`${listMenuProps.id_name}${index}`} {...listMenuProps} />
      ));
    }

    let pages = null;

    if (isMShops && mshopsCategory.pages && mshopsCategory.visible) {
      pages = mshopsCategory.pages.map((page) => (
        <Node key={page.id} node={page} menuOrder={page.menu_order} />
      ));

      pages.push(subList);
      return subList;
    }
    if (
      isApplicationManagement
      && applicationManagementCategoryData
      && applicationManagementCategoryData.pages
      && applicationManagementCategoryData.visible
    ) {
      pages = applicationManagementCategoryData.pages.map((page) => (
        <Node key={page.id} node={page} menuOrder={page.menu_order} />
      ));
      pages.push(subList);
      return subList;
    }
    if (
      isSecurity
      && securityCategoryData
      && securityCategoryData.pages
      && securityCategoryData.visible
    ) {
      pages = securityCategoryData.pages.map((page) => (
        <Node key={page.id} node={page} menuOrder={page.menu_order} />
      ));

      pages.push(subList);
      return subList;
    }
    if (this.props.category.pages && this.props.category.visible) {
      pages = this.props.category.pages.map((page) => (
        <Node key={page.id} node={page} menuOrder={page.menu_order} />
      ));

      if (subList) {
        subList.map((item) => {
          pages.push(item);
          return item;
        });
      }
    }

    return (
      <div>
        {this.props.deviceType === 'desktop' ? (
          <li
            className={
              this.state.selected ? 'list-selected' : 'list-not-selected'
            }
            data-title={node.name}
            key={`menu-item-${node.id}`}
          >
            <input
              id={`input-${node.id}`}
              onClick={this.handleCheck}
              defaultChecked={this.state.selected}
              type="checkbox"
              hidden
              aria-label="input-checkbox"
            />
            <label aria-label="input-checkbox" htmlFor={`input-${node.id}`}>
              <span className="fa fa-angle-right" />
              {node.name}
            </label>
            <ul className={node.class_name}>
              {pages
                ? pages.sort((a, b) => a.props.menuOrder - b.props.menuOrder)
                : subList}
            </ul>
          </li>
        ) : (
          <li
            className={
              this.state.selected ? 'list-selected' : 'list-not-selected'
            }
            key={node.id}
          >
            <input
              className="list-menu__input-checkbox"
              id={node.id_name}
              onClick={this.handleCheck}
              defaultChecked={this.state.selected}
              type="checkbox"
            />
            <label className="list-menu__dropdown-label" htmlFor={node.id_name}>
              <span className="fa fa-angle-right" />
              {currentPage ? currentPage.title : node.name}
            </label>
            <ul className={node.class_name}>
              {pages
                ? pages.sort((a, b) => a.props.menuOrder - b.props.menuOrder)
                : subList}
            </ul>
          </li>
        )}
      </div>
    );
  }
}

module.exports = ListMenu;
